<template>
	<ul
		class="dropdown-menu dropdown-category dropdown_list"
		:class="{
			'selected': open,
			'show': open,
			'overflow-y-auto': overflowYAuto,
		}"
		role="menu"
		:style="listStyles"
	>
		<li
			v-for="opt in options"
			:data-tippy="opt.key"
			@click="handleOptionClick(opt)"
			:id="opt.key"
			:key="opt.key"
			:ref="opt.key"
			:disabled="opt.disabled"
			tabindex="0"
			role="menuitem"
			:class="{disabled: opt.disabled}"
		>
			<component
				v-if="opt.component"
				:current-workflow="optionData"
				:is="opt.component"
				:current-workflow-url="optionUrl"
			/>
			<div
				v-else
				tabindex="-1"
				class="item"
				:class="{
					'disabled': opt.disabled,
					'item-with-icon': opt.iconName,
				}"
			>
				<template v-if="opt.iconName">
					<base-icon
						v-if="opt.disabled"
						:icon-color="opt.disabledIconColor"
						:icon-name="opt.disabledIconName"
					/>
					<base-icon v-else :icon-color="opt.iconColor" :icon-name="opt.iconName" />
				</template>
				<span class="no-child">{{ checkOption(opt.value) }}</span>

				<div
					@click.stop
					v-if="opt.isTooltipShown"
					class="dropdown-button-tooltip"
					:content="opt.toolTipMessage"
					v-tippy="{
						zIndex: 20000,
						distance: 0,
						placement: 'left-start',
						trigger: 'click',
						appendTo: () => appendTo(opt.key),
					}"
				/>
			</div>
		</li>
	</ul>
</template>

<script>
import MoreOptionsDuplicate from '@/components/myWorkflows/more-options-duplicate';
import MoreOptionsNewTab from '@/components/myWorkflows/more-options-newtab';
import MoreOptionsShareWorkflow from '@/components/myWorkflows/more-options-share-workflow';

export default {
	name: 'BaseDropdownList',
	props: {
		open: {type: Boolean},
		close: {
			type: Function,
			default() {
				return this.$emit('baseDropdownListClose');
			},
		},
		options: {type: Array, default: Array},
		listWidth: {type: Number, default: 'auto'},
		overflowYAuto: {type: Boolean, default: false},
		optionData: {type: Object},
		optionUrl: {type: String},
		offset: {type: Number, default: 0},
	},
	components: {MoreOptionsDuplicate, MoreOptionsNewTab, MoreOptionsShareWorkflow},
	methods: {
		appendTo(target) {
			return document.querySelector(`[data-tippy="${target}"]`);
		},
		checkOption(value) {
			return typeof value === 'string' ? value : value[this.LANG];
		},
		handleOptionClick({callback, disabled}) {
			if (disabled) return;
			if (callback) callback(123);
			return this.close();
		},
	},
	computed: {
		LANG() {
			return this.$store.state.LANG;
		},
		listStyles() {
			return {
				width: `${this.listWidth}px`,
				transform: `translateX(${this.offset}px)`,
			};
		},
	},
};
</script>

<style lang="scss" src="./../BaseDropdown.scss" scoped></style>
